export default "__VITE_ASSET__Dv50IUGX__"